import BaseApi from './BaseApi'

export default class AccountApi extends BaseApi {
    async signIn (username, password) {
        return this.post(`/api/v1.0/accounts/signin`, {
            username,
            password
        })
    }

    async userInfo () {
        const response = await this.post(`api/v1.0/accounts/userInfo`)

        return response
    }

    async changePassword (params = {
        currentPassword: null,
        newPassword: null
    }) {
        return this.put('/api/v1.0/accounts/changePassword', params)
    }

    async changeSettings (params = {
        speedUnit: null,
        language: null
    }) {
        return this.put('/api/v1.0/accounts/userSettings', params)
    }

    async getUserSettings () {
        return this.get('/api/v1.0/accounts/userSettings')
    }

    async resetPassword (params = {
        userName: null
    }) {
        return this.post(`/api/v1.0/accounts/restartPassword`, params)
    }

    async activateAccount (params = {
        key: null,
        password: null
    }) {
        return this.post(`/api/v1.0/accounts/activateAccount`, params)
    }
}
